import '../assets/stylesheets/about.css'
import OpenBookImage from '../assets/icons/open-book.png';
import Creative from '../assets/icons/creative.png';
import School from '../assets/icons/school.png';
import Teaching from '../assets/icons/teaching.png';
import Writer from '../assets/icons/writer.png';
import Chatting from '../assets/icons/ai-technology.png';

export default function About (){
    return (
        <section id="about">

            <section id="aboutpic">
                <img src={OpenBookImage} alt="buy the talking quokka book by abigail gordon" id="articon1" />
                <img src={Creative} alt="buy the talking quokka book" id="articon2" />
                <img src={School} alt="buy the talking quokka book" id="articon3" /> 
                <img src={Teaching} alt="buy the talking quokka book" id="articon4" />  
                <img src={Writer} alt="buy the talking quokka book" id="articon5" /> 
                <img src={Chatting} alt="buy the talking quokka book" id="articon6" /> 

                <div className="circle"><img id="about_img" src= {require('../assets/images/about_us_2.png')} alt='a.d. gordon bio' /></div>
            </section>

            <section id="aboutcontent">
                <h2>About The Author</h2>
                <p>A.D. Gordon is the author of The Smiling Quokka, a book she wrote spontaneously. This marked the beginning of her writing journey, a passion she discovered after penning her first poem, entitled <em>‘Love’</em>. You can read it below:</p>
                <em>
                <h5>Love</h5>
                <p>Love is a rose</p>
                <p>Love is like when you spew it
                </p>
                <p>With a hose</p>
                <p>Love is tender</p>
                <p>Love is affection</p>
                <p>Love is when you love someone</p>
                <p>Love is always there </p></em>
                <br />
                <p>Born and raised on the beautiful island of Jamaica, surrounded by the Caribbean Sea, A.D. Gordon has cultivated a diverse range of interests. She is passionate about both writing and teaching, and her love for the arts is evident, particularly in her enjoyment of dance. Furthermore, she has a keen interest in languages and looks forward to learning and playing her favorite instrument, the piano, in the near future.
                </p>
                <p>A significant part of A.D. Gordon's life involves spending time with children, finding joy in talking, listening, and laughing with them, often noting their amusing remarks. As a freelancer, she embraces learning and discovering new things, transforming them into opportunities.
                </p>
                <p>A.D. Gordon is described as an ambitious, kind, and helpful individual. Ultimately, she is driven by a desire to inspire others and help them realize their full potential.
                </p>
            </section>
        </section>
    );

}